import React from 'react'

export const LayoutComponent = React.lazy(() => import('./layout.component'))
